<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div :class="[$style['vue-baidu-map'], 'mb-10']">
                <baidu-map :class="$style['bm-view']" :center="center" :zoom="zoom" @ready="handler" :scroll-wheel-zoom="true">
                    <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
                    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" :enableGeolocation="true"></bm-navigation>
                    <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
                    <bm-overview-map anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :isOpen="true"></bm-overview-map>
                    <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
                    <bm-copyright
                      anchor="BMAP_ANCHOR_TOP_RIGHT"
                      :copyright="[{id: 1, content: 'Copyright Message', bounds: {ne: {lng: 110, lat: 40}, sw:{lng: 0, lat: 0}}}, {id: 2, content: '<a>我是版权信息</a>'}]">
                    </bm-copyright>
                    <bm-marker :position="{lng: 116.404, lat: 39.915}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE" @click="infoWindowOpen">
                        <bm-label content="我爱北京天安门" :offset="{width: -35, height: 30}" title="Hover me"/>
                        <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen" title="Info Window Title">
                            <p v-text="contents"></p>
                            <button @click="clear">Clear</button>
                        </bm-info-window>
                    </bm-marker>
                </baidu-map>
            </div>
            <div :class="[$style['vue-baidu-map'], 'mb-10']">
                <baidu-map :class="$style['bm-view']" :center="center1" :zoom="zoom1">
                    <p style="line-height:30px;">bn-view 渲染</p>
                    <bm-view style="width: 100%; height:270px; flex: 1"></bm-view>
                    <bm-panorama></bm-panorama>
                </baidu-map>
            </div>
            <div :class="[$style['vue-baidu-map'], 'mb-10']">
                <baidu-map :class="$style['bm-view']" style="height: 500px" center="北京">
                    <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
                    <bm-marker :position="{lng: 116.404, lat: 39.915}" :dragging="true" :icon="{url: 'http://developer.baidu.com/map/jsdemo/img/fox.gif', size: {width: 300, height: 157}}"></bm-marker>
                </baidu-map>
            </div>
            <div :class="[$style['vue-baidu-map'], 'mb-10']">
                <baidu-map :class="$style['bm-view']" style="height: 500px" center="北京">
                    <bm-overlay
                        pane="labelPane"
                        :class="{[$style.sample]: true, [$style.active]: active}"
                        @draw="draw"
                        @mouseover.native="active = true"
                        @mouseleave.native="active = false">
                        <div style="line-height:20px;" class="fs-14">我爱北京天安门</div>
                        <div @click="handleClick">点击我</div>
                    </bm-overlay>
                </baidu-map>
            </div>
            <div :class="[$style['vue-baidu-map'], 'mb-10']">
                <baidu-map :class="$style['bm-view']" :center="{lng: 105.000, lat: 38.000}" :zoom="4">
                    <bm-point-collection :points="points" shape="BMAP_POINT_SHAPE_STAR" color="red" size="BMAP_POINT_SIZE_SMALL" @click="clickHandler"></bm-point-collection>
                </baidu-map>
            </div>
            <div :class="[$style['vue-baidu-map'], 'mb-10']">
                <baidu-map :class="$style['bm-view']" :center="{lng: 116.404, lat: 39.915}" :zoom="15">
                    <bm-polyline :path="polylinePath" stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="2" :editing="true" @lineupdate="updatePolylinePath"></bm-polyline>
                    <bm-polygon :path="polygonPath1" stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="2" :editing="true" @lineupdate="updatePolygonPath"/>
                    <bm-circle :center="circlePath.center" :radius="circlePath.radius" stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="2" @lineupdate="updateCirclePath" :editing="true"></bm-circle>
                </baidu-map>
            </div>
            <div :class="[$style['vue-baidu-map'], 'mb-10']">
                <baidu-map :class="$style['bm-view']" :center="{lng: 116.404, lat: 39.915}" :zoom="15">
                    <bm-tile
                      :isTransparentPng="true"
                      tileUrlTemplate="../../../assets/1.jpg">
                    </bm-tile>
                    <bm-traffic :predictDate="{weekday: 7, hour: 12}"></bm-traffic>
                </baidu-map>
            </div>
            <div :class="[$style['vue-baidu-map'], 'mb-10']">
                <baidu-map :class="$style['bm-view']"
                  :center="{lng: 116.404, lat: 39.915}"
                  :zoom="14"
                  @mousemove="syncPolyline"
                  @click="paintPolyline"
                  @rightclick="newPolyline" :scroll-wheel-zoom="true">
                  <bm-control>
                    <el-button @click="toggle('polyline')" size="mini">{{ polyline.editing ? '停止绘制' : '开始绘制' }}</el-button>
                  </bm-control>
                  <bm-polyline :path="path" v-for="path of polyline.paths"></bm-polyline>
                </baidu-map>
            </div>
            <div :class="[$style['vue-baidu-map'], 'mb-10']">
                <baidu-map :class="$style['bm-view1']" :center="{lng: 116.404, lat: 39.915}" :zoom="11">
                    <bm-view class="map" center="北京" style="height:300px;width:100%;"></bm-view>
                    <bm-driving
                      start="北京邮电大学西门"
                      end="中关村"
                      startCity="北京"
                      endCity="北京"
                      :auto-viewport="true"
                      ></bm-driving>
                </baidu-map>
            </div>
            <div :class="[$style['vue-baidu-map'], 'mb-10']">
                <baidu-map :class="$style['bm-view1']" :center="{lng: 116.404, lat: 39.915}" :zoom="11">
                    <bm-ground
                      :bounds="{ne: {lng: 110, lat: 40}, sw:{lng: 0, lat: 0}}">
                    </bm-ground>
                    <bm-view class="map" center="北京" style="height:300px;width:100%;"></bm-view>
                    <bm-transit start="百度大厦" end="北京邮电大学西门" :auto-viewport="false" location="北京"></bm-transit>
                    <bm-bus keyword="331" :auto-viewport="true" location="北京"></bm-bus>
                </baidu-map>
            </div>
            <div :class="[$style['vue-baidu-map'], 'mb-10']">
                <baidu-map :class="$style['bm-view1']" :center="{lng: 116.404, lat: 39.915}" :zoom="11">
                    <bm-ground
                      :bounds="{ne: {lng: 110, lat: 40}, sw:{lng: 0, lat: 0}}">
                    </bm-ground>
                    <bm-view class="map" center="北京" style="height:300px;width:100%;"></bm-view>
                    <bm-walking start="天安门" end="北京邮电大学西门" :auto-viewport="true" location="北京"></bm-walking>
                </baidu-map>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    export default{
        data(){
            return {
                center: {lat: 0, lng: 0},
                zoom: 3,
                center1:"北京",
                zoom1:12,
                polyline: {
                    editing: false,
                    paths: []
                },
                contents: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                show:false,
                points: [],
                polylinePath: [
                    {lng: 116.404, lat: 39.915},
                    {lng: 116.405, lat: 39.920},
                    {lng: 116.423493, lat: 39.907445}
                ],
                polygonPath1: [
                    {lng: 116.412732, lat: 39.911707},
                    {lng: 116.39455, lat: 39.910932},
                    {lng: 116.403461, lat: 39.921336}
                ],
                circlePath: {
                    center: {
                      lng: 116.404,
                      lat: 39.915
                    },
                    radius: 500
                },
                active:false
            }
        },
        created(){
            this.$parent.routerLoading();
        },
        methods: {
            handler ({BMap, map}) {
                // console.log(BMap, map)
                this.center.lng = 116.404
                this.center.lat = 39.915
                this.zoom = 15
            },

            toggle (name) {
              this[name].editing = !this[name].editing
            },
            syncPolyline (e) {
              if (!this.polyline.editing) {
                return
              }
              const {paths} = this.polyline
              if (!paths.length) {
                return
              }
              const path = paths[paths.length - 1]
              if (!path.length) {
                return
              }
              if (path.length === 1) {
                path.push(e.point)
              }
              this.$set(path, path.length - 1, e.point)
            },
            newPolyline (e) {
              if (!this.polyline.editing) {
                return
              }
              const {paths} = this.polyline
              if(!paths.length) {
                paths.push([])
              }
              const path = paths[paths.length - 1]
              path.pop()
              if (path.length) {
                paths.push([])
              }
            },
            paintPolyline (e) {
              if (!this.polyline.editing) {
                return
              }
              const {paths} = this.polyline
              !paths.length && paths.push([])
              paths[paths.length - 1].push(e.point)
            },
            infoWindowClose () {
              this.show = false
            },
            infoWindowOpen () {
              this.show = true
            },
            clickHandler (e) {
              alert(`单击点的坐标为：${e.point.lng}, ${e.point.lat}`);
            },
            addPoints () {
              const points = [];
              for (var i = 0; i < 1000; i++) {
                const position = {lng: Math.random() * 40 + 85, lat: Math.random() * 30 + 21}
                points.push(position)
              }
              this.points = points
            },
            updatePolylinePath (e) {
              this.polylinePath = e.target.getPath()
            },
            updatePolygonPath(e) {
              this.polylinePath = e.target.getPath()
            },
            addPolylinePoint () {
              this.polylinePath.push({lng: 116.404, lat: 39.915})
            },
            updateCirclePath (e) {
              this.circlePath.center = e.target.getCenter()
              this.circlePath.radius = e.target.getRadius()
            },
            clear () {
              this.contents = ''
            },
            draw ({el, BMap, map}) {
              const pixel = map.pointToOverlayPixel(new BMap.Point(116.404, 39.915))
              el.style.left = pixel.x - 60 + 'px'
              el.style.top = pixel.y - 20 + 'px'
            },
            handleClick () {
              global.alert('Well done.')
            },
        },
        mounted(){
            this.addPoints()
        }
    }
</script>
<style module>
.bm-view {
  width: 100%;
  height: 300px;
}
.bm-view1{
    width: 100%;
    height: auto
}
.sample {
  width: 120px;
  height: auto;
  background: rgba(0,0,0,0.5);
  overflow: hidden;
  box-shadow: 0 0 5px #000;
  color: #fff;
  text-align: center;
  padding: 10px;
  position: absolute;
}
.sample.active {
  background: rgba(0,0,0,0.75);
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/main-content/vue-baidu-map/vue-baidu-map.vue